var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4.25V14.75M12.125 7.3125C12.125 6.105 10.9499 5.125 9.5 5.125C8.05013 5.125 6.875 6.105 6.875 7.3125C6.875 8.52 8.05013 9.5 9.5 9.5C10.9499 9.5 12.125 10.48 12.125 11.6875C12.125 12.895 10.9499 13.875 9.5 13.875C8.05013 13.875 6.875 12.895 6.875 11.6875",
    stroke: "#35d169",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.125 1.92003C6.45458 1.15082 7.96394 0.746911 9.5 0.749278C14.3326 0.749278 18.25 4.66665 18.25 9.49928C18.25 14.3319 14.3326 18.2493 9.5 18.2493C4.66738 18.2493 0.75 14.3319 0.75 9.49928C0.75 7.9059 1.17613 6.41053 1.92075 5.12428",
    stroke: "#35d169",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarGreen);
export default __webpack_public_path__ + "static/media/dollar-green.ff9accd5d2183bf9782392588e6cbcab.svg";
export { ForwardRef as ReactComponent };